// ----------------------------------------------------------------------------
//   Imports
// ----------------------------------------------------------------------------

// React
import React, { useState, useEffect } from "react";

// Material UI
import {
  Box,
  CircularProgress,
  Stack,
} from "@mui/material";



// ----------------------------------------------------------------------------
//   Main Component
// ----------------------------------------------------------------------------


function LoadingIcon( props ) {
  return (
    <Stack
      height="100%" width="100%"
      alignItems="center" justifyContent="center"
      paddingTop="24px" paddingBottom="65px"
      boxSizing="border-box"
    >
      <svg width={0} height={0}>
        <defs>
          <linearGradient id="loading_icon_gradient" x1="0%" y1="0%" x2="0%" y2="100%">
            <stop offset="0%"   stopColor="#4E2A84" />
            <stop offset="100%" stopColor="#D8D6D6" />
          </linearGradient>
        </defs>
      </svg>
      <CircularProgress
        sx={{ 'svg circle': { stroke: 'url(#loading_icon_gradient)' } }}
        size={72}
        thickness={2}
      />
    </Stack>
  );
}



// ----------------------------------------------------------------------------
//   Export(s)
// ----------------------------------------------------------------------------

export default LoadingIcon;
